













































































































































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";
import moment from "moment";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "TPPClaimsSearch"
})
export default class TPPClaimsSearch extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("getTPPClaims") public getTPPClaims!: () => void;
  @tppClaims.Action("handleClaimNumberParam") public handleClaimNumberParam!: (payload: string) => void;
  @tppClaims.Action("handleClaimStatusParam") public handleClaimStatusParam!: (payload: string[]) => void;
  @tppClaims.Action("handleDateParam") public handleDateParam!: (payload: string) => void;
  @tppClaims.Action("handleNameParam") public handleNameParam!: (payload: string) => void;
  @tppClaims.Action("handleLocationCodeParam") public handleLocationCodeParam!: (payload: string[]) => void;
  @tppClaims.Action("handleLossTypeParam") public handleLossTypeParam!: (payload: string[]) => void;
  @tppClaims.Action("handleResetFilterParams") public handleResetFilterParams!: () => void;

  // ===== Data ===== //
  public menu = false;
  public currentDate = moment().utc().format("YYYY-MM-DD");
  public minDate = moment().subtract(5, "years").format("YYYY-MM-DD");

  // ===== Methods ===== //
  private handleFilterSearch(): void {
    this.getTPPClaims();
  }

  private handleCancelFilterSearch(): void {
    this.handleResetFilterParams();
  }

  // ===== Computed ===== //
  get filterParams() {
    return this.tppClaims.filterParams;
  }

  get claimStatuses() {
    return this.tppClaims.claimStatusesList;
  }

  get facilities() {
    return this.$store.state.facility.facilitiesList;
  }

  get lossTypes() {
    return this.tppClaims.lossTypesList;
  }

  get additionalFiltersDivider() {
    if (this.$vuetify.breakpoint.xl) {
      return "width: 85%; margin-right: 35px;";
    }

    return "width: 80%; margin-right: 50px;";
  }

  get nameParam() {
    return this.filterParams.name;
  }
  set nameParam(newVal: string) {
    this.handleNameParam(newVal);
  }

  get claimNumberParam() {
    return this.filterParams.claim_number;
  }
  set claimNumberParam(newVal: string) {
    this.handleClaimNumberParam(newVal);
  }

  get claimStatusParam() {
    return this.filterParams.status;
  }
  set claimStatusParam(newVal: string[]) {
    this.handleClaimStatusParam(newVal);
  }

  get dateParam() {
    return this.filterParams.date;
  }
  set dateParam(newVal: string) {
    this.handleDateParam(newVal);
  }

  get locationCodeParam() {
    return this.filterParams.location_code;
  }
  set locationCodeParam(newVal: string[]) {
    this.handleLocationCodeParam(newVal);
  }

  get lossTypeParam() {
    return this.filterParams.loss_type;
  }
  set lossTypeParam(newVal: string[]) {
    this.handleLossTypeParam(newVal);
  }

  // ===== Lifecycle ===== //
}
